let isTabPressed = false;
var inList = false;

/*!
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.2.10
 * @link https://github.com/ten1seven/what-input
 * @license MIT | https://github.com/ten1seven/what-input/blob/main/LICENSE
 */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("whatInput",[],t):"object"==typeof exports?exports.whatInput=t():e.whatInput=t()}(this,function(){return i={},n.m=o=[function(e,t){"use strict";e.exports=function(){if("undefined"==typeof document||"undefined"==typeof window)return{ask:function(){return"initial"},element:function(){return null},ignoreKeys:function(){},specificKeys:function(){},registerOnChange:function(){},unRegisterOnChange:function(){}};var t=document.documentElement,n=null,s="initial",u=s,o=Date.now(),i="false",d=["button","input","select","textarea"],r=[],c=[16,17,18,91,93],w=[],p={keydown:"keyboard",keyup:"keyboard",mousedown:"mouse",mousemove:"mouse",MSPointerDown:"pointer",MSPointerMove:"pointer",pointerdown:"pointer",pointermove:"pointer",touchstart:"touch",touchend:"touch"},a=!1,f={x:null,y:null},l={2:"touch",3:"touch",4:"mouse"},m=!1;try{var e=Object.defineProperty({},"passive",{get:function(){m=!0}});window.addEventListener("test",null,e)}catch(e){}var h=function(){var e=!!m&&{passive:!0};document.addEventListener("DOMContentLoaded",v),window.PointerEvent?(window.addEventListener("pointerdown",y),window.addEventListener("pointermove",E)):window.MSPointerEvent?(window.addEventListener("MSPointerDown",y),window.addEventListener("MSPointerMove",E)):(window.addEventListener("mousedown",y),window.addEventListener("mousemove",E),"ontouchstart"in window&&(window.addEventListener("touchstart",y,e),window.addEventListener("touchend",y))),window.addEventListener(O(),E,e),window.addEventListener("keydown",y),window.addEventListener("keyup",y),window.addEventListener("focusin",L),window.addEventListener("focusout",b)},v=function(){if(i=!(t.getAttribute("data-whatpersist")||"false"===document.body.getAttribute("data-whatpersist")))try{window.sessionStorage.getItem("what-input")&&(s=window.sessionStorage.getItem("what-input")),window.sessionStorage.getItem("what-intent")&&(u=window.sessionStorage.getItem("what-intent"))}catch(e){}g("input"),g("intent")},y=function(e){var t=e.which,n=p[e.type];"pointer"===n&&(n=S(e));var o=!w.length&&-1===c.indexOf(t),i=w.length&&-1!==w.indexOf(t),r="keyboard"===n&&t&&(o||i)||"mouse"===n||"touch"===n;if(M(n)&&(r=!1),r&&s!==n&&(x("input",s=n),g("input")),r&&u!==n){var a=document.activeElement;a&&a.nodeName&&(-1===d.indexOf(a.nodeName.toLowerCase())||"button"===a.nodeName.toLowerCase()&&!C(a,"form"))&&(x("intent",u=n),g("intent"))}},g=function(e){t.setAttribute("data-what"+e,"input"===e?s:u),k(e)},E=function(e){var t=p[e.type];"pointer"===t&&(t=S(e)),A(e),(!a&&!M(t)||a&&"wheel"===e.type||"mousewheel"===e.type||"DOMMouseScroll"===e.type)&&u!==t&&(x("intent",u=t),g("intent"))},L=function(e){e.target.nodeName?(n=e.target.nodeName.toLowerCase(),t.setAttribute("data-whatelement",n),e.target.classList&&e.target.classList.length&&t.setAttribute("data-whatclasses",e.target.classList.toString().replace(" ",","))):b()},b=function(){n=null,t.removeAttribute("data-whatelement"),t.removeAttribute("data-whatclasses")},x=function(e,t){if(i)try{window.sessionStorage.setItem("what-"+e,t)}catch(e){}},S=function(e){return"number"==typeof e.pointerType?l[e.pointerType]:"pen"===e.pointerType?"touch":e.pointerType},M=function(e){var t=Date.now(),n="mouse"===e&&"touch"===s&&t-o<200;return o=t,n},O=function(){return"onwheel"in document.createElement("div")?"wheel":void 0!==document.onmousewheel?"mousewheel":"DOMMouseScroll"},k=function(e){for(var t=0,n=r.length;t<n;t++)r[t].type===e&&r[t].fn.call(void 0,"input"===e?s:u)},A=function(e){f.x!==e.screenX||f.y!==e.screenY?(a=!1,f.x=e.screenX,f.y=e.screenY):a=!0},C=function(e,t){var n=window.Element.prototype;if(n.matches||(n.matches=n.msMatchesSelector||n.webkitMatchesSelector),n.closest)return e.closest(t);do{if(e.matches(t))return e;e=e.parentElement||e.parentNode}while(null!==e&&1===e.nodeType);return null};return"addEventListener"in window&&Array.prototype.indexOf&&(p[O()]="mouse",h()),{ask:function(e){return"intent"===e?u:s},element:function(){return n},ignoreKeys:function(e){c=e},specificKeys:function(e){w=e},registerOnChange:function(e,t){r.push({fn:e,type:t||"input"})},unRegisterOnChange:function(e){var t=function(e){for(var t=0,n=r.length;t<n;t++)if(r[t].fn===e)return t}(e);!t&&0!==t||r.splice(t,1)},clearStorage:function(){window.sessionStorage.clear()}}}()}],n.c=i,n.p="",n(0);function n(e){if(i[e])return i[e].exports;var t=i[e]={exports:{},id:e,loaded:!1};return o[e].call(t.exports,t,t.exports,n),t.loaded=!0,t.exports}var o,i});


/**
 * a11y-keydown
 * @version v1.1.3
 * @copyright Tussendoor internet & marketing
 * Fix issue with scrolling up/down when focus is in menu__item--main after scrolling down the page
 */
function a11yTabbingThroughSite(e)
{
    e = e || window.e;
    // stop when key isnt included
    if (['Tab'].indexOf(e.key) == -1) return;

    isTabPressed = true;

    // now we know
    var direction = tabDirection(e);

    const target = e.target;
    const parent = target.parentNode;
    const appendLink = parent.querySelector('.skip-link--after');
    const prependLink = parent.querySelector('.skip-link--before');
    const hiddenLinks = document.querySelectorAll('.skip-link--hidden');

    // Are we in a list
    if (!target.classList.contains('skip-link') && target.closest('[data-skippable]') ) {
        inList = true;
    } else {
        inList = false;
    }

    if (inList === false && hiddenLinks.length !== 0) {
        hiddenLinks.forEach(function(link) {
            link.classList.remove('skip-link--hidden');
        });
    }

    if (target.classList.contains('skip-link') && direction == 1) {
        appendLink.classList.add('skip-link--hidden')
    }

    if (target.classList.contains('skip-link') && direction == 0) {
        prependLink.classList.add('skip-link--hidden')
    }
}

document.addEventListener('keyup', function(event) {
    if (event.key === 'Tab') {
        isTabPressed = false;
    }
});


/*!
* Determines the direction of the tab key
*/
function tabDirection(e) {
    if (e.key === 'Tab') {
        if (e.shiftKey) {
            return 0;
        } else {
            return 1;
        }
    }
}

/*!
* Makes lists skippable
*/
function enableListsToBeSkipped() {
    var lists = document.querySelectorAll('[data-skippable]');
    var text = A11y.skipLinkText;

    if (lists.length === 0) return;

    lists.forEach(function(list) {
        let uniqueId = Math.random().toString(36).substring(7);

        prependSkipTo(list, uniqueId);
        prependSkipLink(list, uniqueId, text);
        appendSkipLink(list, uniqueId, text);
        appendSkipTo(list, uniqueId);
    });
}

/*!
 * Adds skip link before list
 */
function prependSkipLink(list, uniqueId, text) {
    var skipLink = document.createElement('a');
    skipLink.classList.add('skip-link', 'skip-link--inline', 'skip-link--before');
    skipLink.href = '#skip-app-' + uniqueId;
    skipLink.textContent = text;

    list.prepend(skipLink);
}

/*!
 * Adds skip link after list
 */
function appendSkipLink(list, uniqueId, text) {
    var skipLink = document.createElement('a');
    skipLink.classList.add('skip-link', 'skip-link--inline', 'skip-link--after');
    skipLink.href = '#skip-pre-' + uniqueId;
    skipLink.textContent = text;

    list.append(skipLink);
}

/*!
 * Adds skip link target before list
 */
function prependSkipTo(list, uniqueId) {
    var skipTo = list.parentNode;
    skipTo.id = 'skip-pre-' + uniqueId;
}

/*!
 * Adds skip link target after list
 */
function appendSkipTo(list, uniqueId) {
    var skipTo = document.createElement('div');
    skipTo.id = 'skip-app-' + uniqueId;
    list.append(skipTo);
}

function fakeTab(e, target) {
    var bgcolor = getBackgroundColor(e),
        bgLightOrDark = lightOrDark(bgcolor);

    target.classList.add('focus-' + bgLightOrDark);
    target.classList.add('focus-visible');
}

/*!
* Handles focus in event
*/
document.addEventListener('focusin', handleFocusIn);
function handleFocusIn(event) {
    if (!isTabPressed) return;

    var bgcolor = getBackgroundColor(event),
        bgLightOrDark = lightOrDark(bgcolor);

    const previouslyFocused = document.querySelector('.focus-visible');
    if (previouslyFocused) {
        previouslyFocused.classList.remove('focus-dark');
        previouslyFocused.classList.remove('focus-light');
        previouslyFocused.classList.remove('focus-visible');
    }

    event.target.classList.add('focus-' + bgLightOrDark);
    event.target.classList.add('focus-visible');
}

/*!
 * Handles focus out event
 */
document.addEventListener('focusout', handleFocusOut);
function handleFocusOut(event) {
    event.target.classList.remove('focus-dark');
    event.target.classList.remove('focus-light');
    event.target.classList.remove('focus-visible');
}

function lightOrDark(color) {
    var r, g, b, hsp;

    var test = color.replace(/[^\d\s]/g, '').split(' ');
    r = test[0];
    g = test[1];
    b = test[2];

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    if (hsp>127.5) {
        return 'light';
    } else {
        return 'dark';
    }
}

function getBackgroundColor(event) {
    let currentElement = document.activeElement; // Start with the focused element
    var backgroundColor = '';

    while (currentElement) {
        if (currentElement !== document.activeElement) {
            const computedStyle = window.getComputedStyle(currentElement);
            backgroundColor = computedStyle.backgroundColor;

            if (backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
                break; // Stop once we find the first non-transparent background
            }
        }

        currentElement = currentElement.parentElement;
    }

    return backgroundColor;
}

function a11yNavigationHelper(e) {
    e = e || window.e;

    // stop when key isnt included
    if (['Enter','Escape',' ','ArrowLeft','ArrowUp','ArrowRight','ArrowDown'].indexOf(e.key) == -1) return;
    var target = e.target,
        parent = target.parentNode,
        prev = target.previousElementSibling,
        targetParentHasChildren = parent.classList.contains('menu-item-has-children'),
        caretOrNoChildren = (target.classList.contains('menu__caret') || !targetParentHasChildren),
        prevFromParent = parent.previousElementSibling,
        nextFromParent = parent.nextElementSibling;

    var menuList = target.closest('.menu__list') ?? null;
    var isMainMenu = menuList ? menuList.classList.contains('menu__list--main') : false;
    var isSubMenu = menuList ? menuList.classList.contains('menu__list--sub') : false;

    switch(e.key) {
        case 'Enter':
        case ' ': // spacebar
            e.preventDefault();

            if (target.classList.contains('menu__caret') || targetParentHasChildren) {
                // toggle dropdown
                parent.lastElementChild.classList.toggle('active');
                // toggle aria-expanded
                parent.firstElementChild.setAttribute("aria-expanded", (parent.firstElementChild.getAttribute("aria-expanded") == 'false') ? 'true' : 'false');
                // focus <a> in first <li>
                parent.lastElementChild.firstElementChild.firstElementChild.firstChild.focus();
            }
        break;

        case 'Escape':
            e.preventDefault();
            if (isSubMenu) {
                // remove active class
                target.closest('.menu__level').classList.remove('active');
                // set attribute aria-expanded to false
                target.closest('.menu__level').closest('li').querySelector('a').setAttribute('aria-expanded', 'false');
                // focus a in previous submenu
                target.closest('.menu__level').closest('li').querySelector('a').focus();
            }
        break;

        case 'ArrowLeft':
            e.preventDefault();
            // caret
            if (caretOrNoChildren && prev !== null) {
                // select previous element and focus
                prev.focus();
                return;
            }

            // main-menu
            if (isMainMenu && prevFromParent !== null) {
                // select previous list item and focus its <a>
                prevFromParent.querySelector('a').focus();
            }

            // sub-menu
            if (isSubMenu) {
                // remove active class
                target.closest('.menu__level').classList.remove('active');
                // set attribute aria-expanded to false
                target.closest('.menu__level').closest('li').querySelector('a').setAttribute('aria-expanded', 'false');
                // focus a in previous submenu
                target.closest('.menu__level').closest('li').querySelector('a').focus();
            }
        break;

        case 'ArrowUp':
            e.preventDefault();

            if (isMainMenu && targetParentHasChildren) {
                // toggle dropdown
                parent.lastElementChild.classList.add('active');
                // focus <a> in first <li>
                parent.lastElementChild.firstElementChild.lastElementChild.firstChild.focus();
                // toggle aria-expanded on <a>
                parent.firstElementChild.setAttribute("aria-expanded", (parent.firstElementChild.getAttribute("aria-expanded") == 'false') ? 'true' : 'false');
            }

            if (isSubMenu) {
                if (prevFromParent !== null) {
                    // select previous list item and focus its <a>
                    prevFromParent.querySelector('a').focus();
                } else {
                    // focus <a> of last <li> in <ul>
                    target.closest('.menu__list').lastElementChild.firstChild.focus();
                }
            }
        break;

        case 'ArrowRight':
            e.preventDefault();

            // main-menu
            if (isMainMenu && nextFromParent !== null) {
                // focus <a> from next <li>
                nextFromParent.querySelector('a').focus();
            }

            // sub-menu
            if (isSubMenu && parent.querySelector('div') !== null) {
                // toggle dropdown
                parent.lastElementChild.classList.add('active');
                // focus <a> in first <li>
                parent.lastElementChild.firstElementChild.firstElementChild.firstChild.focus();
                // toggle aria-expanded on <a>
                parent.firstElementChild.setAttribute("aria-expanded", (parent.firstElementChild.getAttribute("aria-expanded") == 'false') ? 'true' : 'false');
            }
        break;

        case 'ArrowDown':
            e.preventDefault();

            if (targetParentHasChildren && isMainMenu) {
                // toggle dropdown
                parent.lastElementChild.classList.add('active');
                // focus <a> in first <li>
                parent.lastElementChild.firstElementChild.firstElementChild.firstChild.focus();
                // toggle aria-expanded on <a>
                parent.firstElementChild.setAttribute("aria-expanded", (parent.firstElementChild.getAttribute("aria-expanded") == 'false') ? 'true' : 'false');
            }

            if (isSubMenu) {
                if (nextFromParent !== null) {
                    // focus <a> from next <li>
                    nextFromParent.querySelector('a').focus();
                } else {
                    // focus <a> of first <li> in <ul>
                    target.closest('.menu__list').querySelector('li a').focus();
                }
            }
        break;
    }
}

function a11yTabsHelper(e)
{
    e = e || window.e;

    // stop when key isnt included
    if (['Escape', 'Enter', ' ', 'ArrowLeft','ArrowUp','ArrowRight','ArrowDown'].indexOf(e.key) == -1) return;
    var target = e.target,
        parent = target.parentNode,
        prev = target.previousElementSibling,
        next = target.nextElementSibling;

    // tab navigation and into tab-content
        switch(e.key) {
        case 'ArrowLeft':
            e.preventDefault();

            if (target.classList.contains('js--tab__trigger')) {

                if (prev !== null) {
                    prev.focus();
                    prev.click();
                    fakeTab(e, prev);
                } else {
                    parent.lastElementChild.focus();
                    parent.lastElementChild.click();
                    fakeTab(e, parent.lastElementChild);
                }
            }
        break;

        case 'ArrowRight':
            e.preventDefault();

            if (target.classList.contains('js--tab__trigger')) {
                if (next !== null) {
                    next.focus();
                    next.click();
                    fakeTab(e, next);
                } else {
                    parent.firstElementChild.focus();
                    parent.firstElementChild.click();
                    fakeTab(e, parent.firstElementChild);
                }
            }
        break;

        case 'Enter':
        case ' ': // spacebar
        case 'ArrowDown':
            e.preventDefault();

            if (target.classList.contains('js--tab__trigger')) {
                var data = target.dataset.tab;
                var id = document.getElementById(data);
                var links = id.querySelectorAll('a');

                // find first <a> and focus
                for (var i = 0; i < links.length; i++) {
                    links[0].focus();
                    fakeTab(e, links[0]);
                    return false;
                }
            }
        break;

        case 'Escape':
        case 'ArrowUp':
            if (!target.classList.contains('js--tab__trigger')) {
                let tab = target.closest('.js--tab__target');
                id = tab.id;
                btn = document.querySelector('[data-tab="' + id + '"]');
                btn.focus();
                fakeTab(e, btn);
            }
        break;
    }
}

window.addEventListener('DOMContentLoaded',function () {
    // adds skip links to all marked lists
    enableListsToBeSkipped();

    // navigation helper
    var siteNav = document.getElementById('site-navigation');
    siteNav.addEventListener('keydown', a11yNavigationHelper, false);

    // tab navigation
    var tabs = document.querySelectorAll('.js--tabs');
    tabs.forEach(tab => tab.addEventListener('keydown', a11yTabsHelper));

    // general tabbing
    document.addEventListener('keydown', a11yTabbingThroughSite, false);
});
